import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryHolidaysQueryParams, IGetLaundryHolidaysRes } from "types/laundry"

import laundriesService from "api/laundriesService"

interface IuseGetLaundryHolidaysArgs {
  query: IGetLaundryHolidaysQueryParams
  enabled: boolean
}

const useGetLaundryHolidays = ({query, enabled}: IuseGetLaundryHolidaysArgs) => {
  return useQuery("laundry_holidays", async () => {
    try {
      const res: AxiosResponse<IGetLaundryHolidaysRes> = await laundriesService.getLaundryHolidays(query)

      return res.data
    } catch(err: any) {
      return err.response
    }
  }, { refetchOnWindowFocus: false, enabled })
}

export default useGetLaundryHolidays